var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({bottom:_vm.bottom,height:_vm.height,top:_vm.top}),attrs:{"id":"AqtSpin"}},[_c('Spin',{attrs:{"fix":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }